import React, { Children } from 'react';
import { motion } from 'framer-motion';
export const FadeInStagger = ({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return <motion.div initial="hidden" whileInView="visible" viewport={{
    once: true,
    margin: '-100px'
  }} variants={{
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.15
      }
    }
  }} className={className} data-id="element-10">
      {children}
    </motion.div>;
};
export const FadeIn = ({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return <motion.div variants={{
    hidden: {
      opacity: 0,
      y: 24
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: [0.21, 0.47, 0.32, 0.98]
      }
    }
  }} className={className} data-id="element-11">
      {children}
    </motion.div>;
};
export const FadeInStandalone = ({
  children,
  className = '',
  delay = 0
}: {
  children: React.ReactNode;
  className?: string;
  delay?: number;
}) => {
  return <motion.div initial="hidden" whileInView="visible" viewport={{
    once: true,
    margin: '-50px'
  }} variants={{
    hidden: {
      opacity: 0,
      y: 24
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        delay,
        ease: [0.21, 0.47, 0.32, 0.98]
      }
    }
  }} className={className} data-id="element-12">
      {children}
    </motion.div>;
};